import { GetStaticProps } from 'next';

import { getServerTranslations } from '../../../get-server-side-translations';
import RestaurantsPage from '../../../components/restaurants';

const Restaurants = () => <RestaurantsPage />;
export const getStaticProps: GetStaticProps = async ({ locale }) => {
  const translation = await getServerTranslations(locale, ['common', 'restaurant-onboarding']);
  return {
    props: {
      ...translation,
    },
  };
};
export default Restaurants;
